/** Mirrors `validateSearch` for `/admin/reports` (see `routes/admin/reports.tsx`). */
export type ReportTab = 'overview' | 'daily' | 'adjustments' | 'hours' | 'items' | 'tables' | 'day-close' | 'refunds' | 'fiscal' | 'tax' | 'staff' | 'card-promos'
  // F-MM-N30 — staff meal allowances + customer tabs.
  | 'accounts'
  // F-DEAL-N5 — combos, automatic discounts, promo codes, special prices, upsells.
  | 'deals'
  // Kitchen flow Stage 3 — only rendered when kitchen_flow is on.
  | 'kitchen-flow'

export type ReportsSearch = {
  tab?: ReportTab
  /** YYYY-MM-DD — Daily Sales drill (order list for that day). */
  day?: string
  /** UUID — Daily Sales drill: auto-open this order's drawer (invoice search). */
  order?: string
  /** UUID — Day Close drill (snapshot drawer for that business day). */
  closeId?: string
  /** YYYY-MM — Day Close month being viewed (Business Days table page). */
  month?: string
  // F-RPT-N30 — Orders browser facets, URL-backed so an Overview row can
  // deep-link into "FoodPanda on 4 Sep" and the link is shareable.
  /** CSV of order-type ids (dine_in, ot_…). */
  ot?: string
  /** cash | card | online | gift_card (F-MM-N24). The gift value must be
   *  accepted here or the Tender mix "View orders" drill on a gift row passes
   *  no filter at all and silently lists the whole day — the backend orders
   *  browser already accepts the same four values. */
  pay?: 'cash' | 'card' | 'online' | 'gift_card' | 'house_account' | 'staff_meal' | 'tab'
  /** Online provider slug; only meaningful with pay=online. */
  sub?: string
  /** completed | credit_noted | cancelled | open */
  st?: 'completed' | 'credit_noted' | 'cancelled' | 'open'
  /** Sort column + direction. */
  sort?: string
  dir?: 'asc' | 'desc'
  /** The period bar (`useReportRange`): preset id + DD-MM-YYYY bounds, as a
   *  deep link from another page carries them (F-FE-N129). Pass-through. */
  preset?: string
  from?: string
  to?: string
}

/** The facet keys above — cleared together by "Clear filters". */
export const REPORTS_ORDER_FILTER_KEYS = ['ot', 'pay', 'sub', 'st', 'sort', 'dir'] as const
